import React, { createContext, useState, useMemo, useEffect } from "react"
import intl from "react-intl-universal"

import RcmpModalInfo from "../components/organisms/ModalInfo"

export const ErrorContext = createContext(null)

export const ErrorContextProvider = ({ children }) => {
    const [bIsOpenErrorModal, fnSetBIsOpenErrorModal] = useState(false)
    const [bErrorModalWasClosed, fnSetBErrorModalWasClosed] = useState(false)
    const [cErrorMessage, fnSetCErrorMessage] = useState("")

    function fnOpenErrorModal(cMessage) {
        fnSetCErrorMessage(cMessage)
        fnSetBIsOpenErrorModal(true)
    }

    function fnCloseErrorModal() {
        fnSetCErrorMessage("")
        fnSetBIsOpenErrorModal(false)
        fnSetBErrorModalWasClosed(true)
    }

    useEffect(() => {
        if (!bIsOpenErrorModal && bErrorModalWasClosed)

            fnSetBErrorModalWasClosed(false)
    }, [bIsOpenErrorModal, bErrorModalWasClosed])

    const value = useMemo(() => {
        return { bIsOpenErrorModal, bErrorModalWasClosed, fnOpenErrorModal }
    }, [bIsOpenErrorModal, bErrorModalWasClosed])

    return (
        <ErrorContext.Provider value={value}>
            {children}
            <RcmpModalInfo
                bIsOpen={bIsOpenErrorModal}
                size="sm"
                title={intl.get("generic_error")}
                description={cErrorMessage}
                fnHandleCancel={fnCloseErrorModal}
                fnHandleConfirm={fnCloseErrorModal}
                buttonSaveText={intl.get("close")}
                oButtonCancelProps={{ style: { display: "none" } }}
                oButtonSaveProps={{ style: { marginLeft: "auto" } }}
            />
        </ErrorContext.Provider>
    )
}

export default ErrorContext